<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col size="12">
        <ion-card class="outline-card">
          <ion-card-title class="card-title">
            <h3>Conversations</h3>
          </ion-card-title>
          <div
            *ngIf="conversations && !conversations.length"
            class="empty-state-container"
            style="padding: 60px"
          >
            <span class="placeholder-emoji">
              <ion-icon name="file-tray-outline"></ion-icon>
            </span>
            <h1 class="placeholder-title">Nothing to see here</h1>
            <p class="placeholder-subtitle">
              There are no conversations with this customer yet.
            </p>
          </div>
          <div
            *ngIf="!conversations"
            class="empty-state-container"
            style="padding: 100px 0"
          >
            <ion-spinner
              name="crescent"
              style="margin-left: auto; margin-right: auto"
            ></ion-spinner>
          </div>
          <ngx-datatable
            class="material"
            columnMode="force"
            [limit]="100"
            [headerHeight]="50"
            [footerHeight]="50"
            [rowHeight]="50"
            [scrollbarH]="true"
            [rows]="conversations"
            [reorderable]="true"
            *ngIf="conversations && conversations.length"
          >
            <ngx-datatable-column
              name="Message"
              prop="initialMessage"
              [minWidth]="400"
              [sortable]="false"
            >
              <ng-template
                let-value="value"
                let-row="row"
                ngx-datatable-cell-template
              >
                <a
                  [routerLink]="['/dashboard/inbox/all/conversations', row.id]"
                  title="{{ formatContent(row) }}"
                >
                  <strong
                    >[#{{ row.friendlyId }}] {{ formatContent(row) }}</strong
                  >
                </a>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
              name="Status"
              [minWidth]="140"
              [maxWidth]="140"
            >
              <ng-template
                let-value="value"
                let-row="row"
                ngx-datatable-cell-template
              >
                <div
                  class="status-label status-label-needs-response"
                  *ngIf="value === 'open'"
                  style="font-size: 0.8rem"
                >
                  <ion-icon name="custom-open"></ion-icon>
                  Needs response
                </div>
                <div
                  class="status-label status-label-in-progress"
                  *ngIf="value === 'in_progress'"
                  style="font-size: 0.8rem"
                >
                  <ion-icon name="custom-in-progress"></ion-icon>
                  In Progress
                </div>
                <div
                  class="status-label status-label-on-hold"
                  *ngIf="value === 'on_hold'"
                  style="font-size: 0.8rem"
                >
                  <ion-icon name="custom-on-hold"></ion-icon>
                  On Hold
                </div>
                <div
                  class="status-label status-label-closed"
                  *ngIf="value === 'closed'"
                  style="font-size: 0.8rem"
                >
                  <ion-icon name="custom-closed"></ion-icon>
                  Closed
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
              name="Assignee"
              prop="assignedToUser"
              [minWidth]="200"
              [sortable]="false"
            >
              <ng-template let-value="value" ngx-datatable-cell-template>
                {{ value ? value.name : "None" }}
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
              name="Date"
              prop="createdAt"
              [minWidth]="100"
              [sortable]="false"
            >
              <ng-template
                let-value="value"
                let-row="row"
                ngx-datatable-cell-template
              >
                {{ value | date: "MMM d yyyy h:mm a" }}
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </ion-card>
      </ion-col>
      <ion-col size="6">
        <ion-card class="outline-card">
          <ion-card-title class="card-title flex-space-between">
            <h3>
              Conversations started
              <span class="subtitle"> Last 60 days </span>
            </h3>
          </ion-card-title>
          <div class="padded">
            <canvas
              baseChart
              [datasets]="convoChartData"
              [labels]="convoChartLabels"
              [options]="convoChartOptions"
              type="line"
            >
            </canvas>
          </div>
        </ion-card>
      </ion-col>
      <ion-col size="6">
        <ion-card class="outline-card">
          <ion-card-title class="card-title flex-space-between">
            <h3>
              Channel members
              <span class="subtitle"> Last 60 days </span>
            </h3>
            <ion-button
              fill="clear"
              class="download-button"
              (click)="viewMembers()"
            >
              View
              <ion-icon
                name="chevron-forward-outline"
                class="icon-padded-left"
              ></ion-icon>
            </ion-button>
          </ion-card-title>
          <div class="padded">
            <canvas
              baseChart
              [datasets]="memberChartData"
              [labels]="memberChartLabels"
              [options]="memberChartOptions"
              type="line"
            >
            </canvas>
          </div>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
